'use client'

import { useEffect, useRef } from 'react'

import { useLocale } from 'next-intl'

type FormWithValidation = {
  state: {
    fieldMeta: Record<string, { errors?: unknown[] } | undefined>
    isDirty: boolean
    isTouched: boolean
  }
  validate: (cause: 'change') => Promise<unknown>
}

export function useRevalidateFormOnLocaleChange(form: FormWithValidation) {
  const locale = useLocale()
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    const { fieldMeta, isDirty, isTouched } = form.state
    const hasErrors = Object.values(fieldMeta).some(
      (meta) => (meta?.errors?.length ?? 0) > 0
    )

    if (!isDirty && !isTouched && !hasErrors) return

    void form.validate('change')
    // Only re-run when locale changes; form reference is stable from TanStack Form.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional
  }, [locale])
}
